import { CustomElement } from '@aurelia/runtime-html';
export const name = "chip-component";
export const template = "<div\n  class=\"font-raleway min-w-16 w-fit flex items-center gap-2 rounded-full chip-box-${chipSize} chip-${chipStyle}-${chipType}\">\n  ${labelText}\n  <div if.bind=\"canClose\"\n    class=\"flex items-center justify-center text-center align-middle w-4 h-4 !text-base mr-[-4px]\">\n    <i click.trigger=\"closeFunction()\" class=\"cursor-pointer mdi mdi-window-close s\"></i>\n  </div>\n</div>";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
